import { useState } from 'react';

export default function AppEntry() {
  const [imgError, setImgError] = useState(false);

  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">移动观影</h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-5 max-w-md mx-auto lg:mx-0">
              蓝莓影院移动端适配完美，在手机和平板上同样享受高清流畅的观影体验。
              通勤路上、午休间隙、睡前时光，随时随地打开蓝莓影院，精彩影视随身同行。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-full cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-android-line text-lg"></i>
                Android 版
              </div>
              <div className="flex items-center gap-2 px-4 py-2.5 bg-foreground-900 text-background-50 rounded-full cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-apple-line text-lg"></i>
                iOS 版
              </div>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            {!imgError ? (
              <div className="w-full max-w-[360px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20mobile%20phone%20showing%20a%20movie%20streaming%20app%20interface%20with%20warm%20amber%20and%20coral%20color%20scheme%2C%20clean%20modern%20UI%20with%20movie%20posters%20grid%20layout%2C%20dark%20mode%20design%20with%20soft%20golden%20accents%2C%20minimalist%20sophisticated%20app%20screen%20mockup&width=720&height=1280&seq=app-screen-01&orientation=portrait"
                  alt="Blueberry cinema mobile app interface"
                  className="w-full h-full object-cover"
                  onError={() => setImgError(true)}
                />
              </div>
            ) : (
              <div className="w-full max-w-[360px] aspect-[9/16] rounded-2xl bg-background-100 border-4 border-background-200 flex items-center justify-center">
                <i className="ri-smartphone-line text-5xl text-foreground-300"></i>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}